"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _HBBaseFormField = _interopRequireDefault(require("../HBBaseFormField/HBBaseFormField"));
var HBFormField = function HBFormField(props) {
  var _useField = (0, _formik.useField)(props.id),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 2),
    error = _useField2[1].error;
  return /*#__PURE__*/_react["default"].createElement(_HBBaseFormField["default"], (0, _extends2["default"])({}, props, {
    error: !!error,
    errorMessage: error
  }));
};
var _default = exports["default"] = HBFormField;
//# sourceMappingURL=HBFormField.js.map